import React, { useRef } from "react";
import AppTable from "../../common/AppTable/AppTable";

const TableOfDocuments = ({
  isUnlink,
  unlinkModules,
  children,
  moduleData,
  setSearchQuery,
  setLocalSortConfig,
  pagination,
  columns: customColumns,
  disableSearch = false,
  tableTitle = "Table Of Documents",
}) => {
  const tableContainerRef = useRef();
  // Default columns (with Training Status and Rev) - used in Preview
  const defaultColumns = [
    {
      headName: "Item Code",
      field: "partNumber",
      sort: true,
      filter: true,
      required: true,
    },
    { headName: "Type", field: "type", sort: true, filter: true },
    { headName: "Description", field: "description", sort: true, filter: true },
    { headName: "Training Status", field: "trainingStatus", sort: false, filter: false },
    { headName: "Rev", field: "rev", sort: false, filter: false },
    { headName: "Action", field: "Action", textCenter: true },
  ];
  // Use custom columns if provided, otherwise use default columns
  const columns = customColumns || defaultColumns;
  const tableHeading = <h3 className="table-heading">{tableTitle}</h3>;
  return (
    <>
    <div>
      {!moduleData && tableHeading}
      <AppTable
        ref={tableContainerRef}
        columnsData={columns}
        showSearchInput={disableSearch ? false : moduleData ? true : false}
        extrapadding="0px"
        searchInputPosition="right"
        searchBarLeftContent={
          <>
            <div style={{ marginTop: "45px" }}></div>
            {tableHeading}
          </>
        }
        onFilterSortHandler={disableSearch ? undefined : setSearchQuery}
        setLocalSortConfig={setLocalSortConfig}
        paginate={isUnlink ? true : false}
        pagination={pagination}
      >
        {children}
      </AppTable>
    </div>
    </>
  );
};

export default TableOfDocuments;
